import { useState, useEffect, useCallback } from "react";
import { cursorState } from "./cursorState";

export function useCustomCursor() {
  const [snapshot, setSnapshot] = useState(cursorState.getSnapshot);

  useEffect(() => {
    return cursorState.subscribe(setSnapshot);
  }, []);

  const setMode = useCallback((mode, label = "") => {
    cursorState.setMode(mode, label);
  }, []);

  const reset = useCallback(() => {
    cursorState.reset();
  }, []);

  const startLoading = useCallback((ownerKey) => {
    cursorState.startLoading(ownerKey);
  }, []);

  const stopLoading = useCallback((ownerKey) => {
    cursorState.stopLoading(ownerKey);
  }, []);

  const triggerSuccess = useCallback((durationMs) => {
    cursorState.triggerSuccess(durationMs);
  }, []);

  const triggerError = useCallback((durationMs) => {
    cursorState.triggerError(durationMs);
  }, []);

  return {
    ...snapshot,
    setMode,
    reset,
    startLoading,
    stopLoading,
    triggerSuccess,
    triggerError,
  };
}

export default useCustomCursor;
